/**
 * PRD.329 — Laboratory Department queries. Pure logic (identity, validation,
 * ordering) lives in `laboratory-departments-logic.ts` and is re-exported here
 * so callers have one import surface.
 */
import type { QuerySpec } from '@helios/powersync-client-core';

export * from './laboratory-departments-logic.js';

/** Every department (active and disabled), in picker order. */
export function qLaboratoryDepartments(): QuerySpec<[]> {
  return {
    key: ['laboratory_departments', 'all'] as const,
    sql: `SELECT * FROM laboratory_departments
          ORDER BY COALESCE(sort_order, 0) ASC, name COLLATE NOCASE ASC`,
    params: [],
    watch: ['laboratory_departments'],
  };
}
